export default __webpack_public_path__ + "static/media/prakhar.2ebed1ce.jpeg";